const baseURL = 'https://info.vodokanal.mk.ua/api/';
const enterpriseApiUrl = 'https://cent.vodokanal.mk.ua/'

export default baseURL;
